var map = {
	"./add-plus.svg": "5fdc",
	"./between.svg": "c77d",
	"./camera.svg": "5b31",
	"./close-round.svg": "4f15",
	"./files.svg": "a10d",
	"./import.svg": "1fb4",
	"./lamp-close.svg": "3a99",
	"./lamp-control.svg": "a095",
	"./lamp-open.svg": "b9b6",
	"./question.svg": "5d9e",
	"./retract.svg": "d072",
	"./roll-bottom.svg": "7186",
	"./roll-right.svg": "3b5a",
	"./search.svg": "679a",
	"./video-preview.svg": "edaa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";